import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import UserMenu from "apps/messenger/components/shared/MessengerUserRow/UserMenu";

import {
	onBlock,
	onUnmatch,
	onReport,
	closeConversation,
} from "ducks/global_messaging";

const mapStateToProps = (state, props) => {
	const {
		fields: {
			likes: {
				mutual_like: isMutualLike = false,
			} = {},
		} = {},
		properties: {
			last_received_timestamp: lastReceivedTimestamp,
		} = {},
		nway,
	} = (state.globalMessaging.conversationData[props.userid] || {});

	// Only allow reporting if we've received a message from them.
	const allowReport = lastReceivedTimestamp !== 0;

	return {
		allowReport,
		isMutualLike: !!isMutualLike,
		nway,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			onBlock,
			onUnmatch,
			onReport,
			closeConversation,
		},
		dispatch,
	);
};


export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(UserMenu);



// WEBPACK FOOTER //
// ./src/apps/messenger/containers/UserMenu.js